var React = require('react');

function EllipsisV (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 184a72 72 0 1 0 72 72 72 72 0 0 0-72-72z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 152a72 72 0 1 0-72-72 72 72 0 0 0 72 72zm0 208a72 72 0 1 0 72 72 72 72 0 0 0-72-72z","className":"fa-primary","key":2})]);
}

EllipsisV.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = EllipsisV;

EllipsisV.default = EllipsisV;
